import { Content, LayoutContainer, useNotification } from 'common-components'
import { Outlet } from 'react-router'
import { useTranslation } from '@hooks'
import { useEffect } from 'react'
import { store } from '@store'

import { NavBar } from '../navigation/nav-bar'
import VersionFooter from '../VersionFooter'

export const RootLayout = () => {
  const error = store.use.error()
  const success = store.use.success()

  const deleteErrorNotificationAction = store.use.deleteErrorNotificationAction()
  const deleteSuccessNotificationAction = store.use.deleteSuccessNotificationAction()

  const { contextHolder, notification } = useNotification()
  const { translate: t } = useTranslation()

  useEffect(() => {
    if (error?.id) {
      const message = error?.messageTranslate ? t(error.messageTranslate) : undefined
      const description = error?.descriptionTranslate
        ? t(error.descriptionTranslate)
        : error?.description

      notification.error({
        message,
        description,
        duration: error?.duration,
        onClose: () => deleteErrorNotificationAction(),
      })
    }
  }, [error?.id])

  useEffect(() => {
    if (success?.id) {
      const message = success?.messageTranslate ? t(success.messageTranslate) : undefined
      const description = success?.descriptionTranslate
        ? t(success.descriptionTranslate)
        : undefined

      notification.success({
        message,
        description,
        duration: success?.duration,
        onClose: () => deleteSuccessNotificationAction(),
      })
    }
  }, [success?.id])

  return (
    <LayoutContainer>
      {contextHolder}
      <NavBar />
      {/* @ts-ignore */}
      <Content>
        <Outlet />
      </Content>
      <VersionFooter />
    </LayoutContainer>
  )
}
